'use client';

import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@/context/ThemeContext';
import { queryClient } from '@/lib/queryClient';

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider data-component-id="src/app/providers.tsx:10:4" data-component-path="src/app/providers.tsx" data-component-line="10" data-component-end-line="12" data-component-file="providers.tsx" data-component-name="QueryClientProvider" data-component-content="%7B%22elementName%22%3A%22QueryClientProvider%22%7D" client={queryClient}>
      <ThemeProvider data-component-id="src/app/providers.tsx:11:6" data-component-path="src/app/providers.tsx" data-component-line="11" data-component-end-line="11" data-component-file="providers.tsx" data-component-name="ThemeProvider" data-component-content="%7B%22elementName%22%3A%22ThemeProvider%22%7D">{children}</ThemeProvider>
    </QueryClientProvider>
  );
}

